import request from '@/utils/httpRequest'
/*
 * @author: xz
 * @date: 2021/04/27
 * */
/*
 * @Description: 菜单
 * */
export function getMenuList (museumcode) {
  return request({
    url: '/api/admin/front/menu/department/' + museumcode,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/menu/index.js